import * as React from 'react';

const VoucherRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={36} height={32} viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#voucher-rebranding_svg__clip0_101_1042)" fill="#000">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M96 96c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32zm0-4c8.391 0 15.919-3.69 21.051-9.537C112.971 75.035 105.074 70 96.001 70c-9.074 0-16.971 5.035-21.051 12.464C80.082 88.31 87.61 92 96 92zm10.5-37c0 5.799-4.701 10.5-10.5 10.5S85.5 60.799 85.5 55 90.201 44.5 96 44.5s10.5 4.701 10.5 10.5z"
            />
            <path d="M24 55v-4c7-.5 9.86-4 11-9h7v40h8v4H24v-4h8V55h-8zM142 51v4h8v27h-8v4h26v-4h-8V42h-7c-1.139 5-4 8.5-11 9z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 4a4 4 0 014-4h184a4 4 0 014 4v120a4 4 0 01-4 4H4a4 4 0 01-4-4V4zm8 116V8h176v112H8z"
            />
        </g>
        <defs>
            <clipPath id="voucher-rebranding_svg__clip0_101_1042">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

VoucherRebrandingSvg.displayName = 'VoucherRebrandingSvg';
export default VoucherRebrandingSvg;
